import Vue from 'vue';

import VueExpandableImage from 'vue-expandable-image';
Vue.use(VueExpandableImage);
